import Translator from './translator';

export default function (key) {
  return Translator.trans(key);
}
